import { createFileRoute } from "@tanstack/react-router";

import { TypesSeancePage } from "@/features/referentiels/TypesSeancePage";

export const Route = createFileRoute("/_connecte/types-seance")({
  component: TypesSeancePage,
});
